var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import reactHoc from 'react-hoc';
import uniqueId from 'lodash.uniqueid';

/**
 * @class StableUniqueId
 */

var StableUniqueId = function (_React$Component) {
  _inherits(StableUniqueId, _React$Component);

  function StableUniqueId() {
    _classCallCheck(this, StableUniqueId);

    return _possibleConstructorReturn(this, (StableUniqueId.__proto__ || Object.getPrototypeOf(StableUniqueId)).apply(this, arguments));
  }

  _createClass(StableUniqueId, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var uniqueIdFn = this.props.uniqueIdFn;

      this.setState({ uniqueId: uniqueIdFn() });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          render = _props.render,
          prefix = _props.prefix,
          uniqueIdFn = _props.uniqueIdFn;
      var uniqueId = this.state.uniqueId;

      return render({ uniqueId: '' + (prefix || '') + uniqueId });
    }
  }]);

  return StableUniqueId;
}(React.Component);

StableUniqueId.propTypes = {
  /**
   * ({ uniqueId: string }) => JSX
   */
  render: PropTypes.func.isRequired,
  /**
   * Optionally applies a prefix to the generated ID.
   */
  prefix: PropTypes.string,
  /**
   * () => string
   * Provide a custom function to generate the unique ID. Useful for testing.
   * Defaults to lodash's `uniqueId` function.
   *
   * NOTE: will only be called once, when the function is mounted. Updating this function will not change the uniqueId.
   */
  uniqueIdFn: PropTypes.func
};
StableUniqueId.defaultProps = {
  uniqueIdFn: uniqueId
};
export default StableUniqueId;

/**
 * @param {object} opts
 * @param {string} opts.prefix
 * @param {string} opts.name The name of the string prop that will be passed to the component
 */
var withStableUniqueId = function withStableUniqueId() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      prefix = _ref.prefix,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? 'uniqueId' : _ref$name,
      uniqueIdFn = _ref.uniqueIdFn;

  return reactHoc(
  // eslint-disable-next-line react/display-name
  function (Component) {
    return function (_ref2) {
      var _uniqueIdFn = _ref2._uniqueIdFn,
          props = _objectWithoutProperties(_ref2, ['_uniqueIdFn']);

      return React.createElement(StableUniqueId, {
        prefix: prefix,
        render: function render(_ref3) {
          var uniqueId = _ref3.uniqueId;

          var childProps = _extends(_defineProperty({}, name, uniqueId), props);
          if (_uniqueIdFn) {
            childProps._uniqueIdFn = _uniqueIdFn;
          }
          return React.createElement(Component, childProps);
        },
        uniqueIdFn: _uniqueIdFn || uniqueIdFn
      });
    };
  }, 'withStableUniqueId');
};
export { withStableUniqueId };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-stable-uniqueid/dist-es6/index.js
// module id = 198
// module chunks = 0